const TESTIMONIALS = [
  {
    quote:
      "SeedTechNG built our data room and financial model in under three weeks. We closed our $1.2M seed round shortly after.",
    name: "Adaeze O.",
    role: "Founder, AgriTech startup — Lagos",
  },
  {
    quote:
      "Their grant application was so clean we won a Mastercard Foundation grant we'd been turned down for twice before.",
    name: "Samuel K.",
    role: "CEO, Logistics SME — Nairobi",
  },
  {
    quote:
      "Worth every dollar. The pitch deck alone got us into three investor meetings in the first month.",
    name: "Ifeoma N.",
    role: "Co-founder, HealthTech — Accra",
  },
];

export default function Testimonials() {
  return (
    <section className="relative overflow-hidden bg-umber py-24 text-cream sm:py-32">
      <div className="absolute inset-0 bg-adinkra opacity-[0.06]" />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-12">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Trusted across the continent</p>
            <h2 className="mt-3 font-display text-4xl font-semibold sm:text-5xl">
              Founders we&apos;ve helped <span className="italic text-gold">win.</span>
            </h2>
          </div>
          <p className="max-w-sm text-cream/65">
            From Lagos to Cairo to Cape Town — over 120 African businesses have trusted us with their funding journey.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl border border-cream/10 bg-cream/5 p-7 backdrop-blur"
            >
              <span className="font-display text-5xl leading-none text-gold">&ldquo;</span>
              <blockquote className="mt-2 text-cream/90">{t.quote}</blockquote>
              <figcaption className="mt-6 border-t border-cream/10 pt-4">
                <div className="font-medium">{t.name}</div>
                <div className="text-xs text-cream/55">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
